import { connect } from 'react-redux';
import MediaGallery from '../components/MediaGallery';
import { State } from '../core/reducers';
import {
    showCMessage
} from '../core/actions/calls';

const mapStateToProps = (state: State) => ({
  userId: state.sdk.userId,
  displayName: state.calls.callAgent?.displayName,
  remoteParticipants: state.calls.remoteParticipants,
    dominantParticipants: state.calls.dominantParticipants,
    showMessage: false,
    cogbeeMessage:''
});


const mapDispatchToProps = (dispatch: any) => ({
    
    showMessages: (isShowMessage: boolean, message: string) => dispatch(showCMessage(isShowMessage, message))
 
});



const connector: any = connect(mapStateToProps, mapDispatchToProps);
export default connector(MediaGallery);
